"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplateHeader = exports.PageTemplateHeaderActions = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const blue_1 = __importDefault(require("@material-ui/core/colors/blue"));
const StyledHeader = styled_components_1.default.div `
  display: flex;
  color: #fff;
  padding: 42px 0;
  align-items: center;
  white-space: nowrap;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    color: ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerText) ||
        props.theme.palette.primary.contrastText;
}};
  }
  h2 {
    font-size: 22px;
  }
  .subtitle {
    margin-top: 4px;
    color: ${props => {
    var _a;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerText) ||
        props.theme.palette.primary.contrastText;
}};
  }
  a {
    color: ${props => {
    var _a, _b;
    return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerLink) ||
        ((_b = props.theme.pageTemplate) === null || _b === void 0 ? void 0 : _b.headerText) ||
        props.theme.palette.primary.contrastText;
}};
    &:hover {
      color: ${props => { var _a; return ((_a = props.theme.pageTemplate) === null || _a === void 0 ? void 0 : _a.headerHoverLink) || blue_1.default[100]; }};
    }
  }
  ${props => props.theme.breakpoints.down('sm')} {
    flex-wrap: wrap;
    h1,
    h2,
    h3,
    h4 {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .MuiBreadcrumbs-root {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      ol {
        flex-wrap: nowrap;
        /* justify-content: flex-end;
        padding-right: 10px; */
      }
    }
    .page-template-header-actions {
      flex: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .search-box {
      order: 5;
      flex: 100%;
      margin: 10px 0 0 0;
      .search {
        padding: 12px;
        max-width: 100%;
        border-radius: 4px 4px 0 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
`;
const StyledCardHeaderActions = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &.flex {
    flex: 1;
  }
  .MuiButton-label {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
const PageTemplateHeaderActions = (_a) => {
    var { className, flex, children } = _a, props = __rest(_a, ["className", "flex", "children"]);
    const classes = ['page-template-header-actions'];
    if (className)
        classes.push(className);
    if (flex)
        classes.push('flex');
    return (react_1.default.createElement(StyledCardHeaderActions, Object.assign({ className: classes.join(' ') }, props), children));
};
exports.PageTemplateHeaderActions = PageTemplateHeaderActions;
const PageTemplateHeader = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(StyledHeader, Object.assign({ className: `page-template-header${className ? ` ${className}` : ''}` }, props), children));
};
exports.PageTemplateHeader = PageTemplateHeader;
exports.default = exports.PageTemplateHeader;
//# sourceMappingURL=PageTemplateHeader.js.map